import { $alert } from 'signals/global.signals';

const displayError = (error) => {
  const {
    message,
    title = 'Error',
    timeOut = 7000,
    variant = 'danger',
  } = error;
  console.error('DealSend Error', error);
  $alert.update({
    variant,
    message: import.meta.env.VITE_APP_ENV === 'development' ? message : 'An error occurred',
    title,
    timeOut,
  });
};

export default displayError;
